import { gql } from "@apollo/client";
export const CREATE_COMMERCIAL_USER = gql`
 mutation CreateCommercialUser($signup_input:SignupInput!) {
    createCommercialUser(signup_input: $signup_input) {
        data {
            profile {
                created_at
                gender
                id
                name
                profile_picture
                updated_at
            }
            user {
                created_at
                email
                id
                mobile_no
                status
                updated_at
                user_identifier
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;

export const CREATE_COMMERCIAL_USER_PROFILE = gql`
mutation CreateCommercialUserProfile($input:UserProfileInput) {
    createCommercialUserProfile(input: $input) {
        data {
            user_profile {
                created_at
                gender
                id
                name
                profile_picture
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;
export const RESET_COMMERCIAL_USER_PASSWORD = gql`
mutation ResetCommercialPassword($password:String!, $confirm_password:String!,$user_id:UUID!) {
    resetCommercialPassword(password: $password, confirm_password: $confirm_password, user_id: $user_id) {
        data {
            message
        }
        error {
            code
            field
            message
        }
    }
}
`;


export const UPDATE_COMMERCIAL_USER = gql`
mutation UpdateCommercialUser($user_id:UUID, $signup_input:SignupInput!) {
    updateCommercialUser(user_id: $user_id, signup_input: $signup_input) {
        data {
            profile {
                created_at
                gender
                id
                name
                profile_picture
                updated_at
            }
            user {
                created_at
                email
                id
                mobile_no
                status
                updated_at
                user_identifier
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const UPDATE_COMMERCIAL_USER_STATUS = gql`
 mutation UpdateCommercialUserStatus($userID:UUID!,$status:String!) {
    updateCommercialUserStatus(userID: $userID, status: $status) {
        data {
            user {
                created_at
                email
                id
                mobile_no
                status
                updated_at
                user_identifier
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

